// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "be3f9d2cf5b16bc4e7b511d3913b4e6c" + ".js";
};